import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    padding: '50px 48px 32px',
  },
  cursorDefault: {
    cursor: 'default',
  },
  invoiceCardContainer: {
    backgroundColor: '#F9F9F9',
    maxWidth: 250,
    padding: '16px 24px',
    width: '100%',
  },
  listItem: {
    width: '100%',
    padding: '0 4px 0 0',
    borderBottom: `1px solid ${theme.palette.dividers.primary}`,

    '&:last-child': {
      border: 0,
      '& .MuiListItemText-secondary': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  link: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

export { useStyles };
